const businessLandingEN = {
	hero: {
		title: "Organize your business. Fill your schedule. No lines.",
		subtitle:
			"Sin Fila automates bookings, reduces no-shows, and helps you get more clients.",
		primaryCta: "Get started",
		secondaryCta: "See how it works",
	},

	problem: {
		title: "Does this sound familiar?",
		items: [
			"You reply to WhatsApp all day (and night)",
			"Overlapping schedules and empty slots",
			"Clients see a long line and leave",
			"Walk-ins get frustrated and leave",
		],
		highlight: "Every client lost to a line is lost revenue.",
		stat: "Many businesses lose up to 20% of income due to poor scheduling.",
	},

	solution: {
		title: "Sin Fila fixes it",
		business: {
			title: "For your business",
			items: [
				"Automatic scheduling 24/7",
				"Confirmations and reminders",
				"Flexible hours and time blocking",
				"Public profile to attract new clients",
				"Promotions for slow hours",
			],
		},
		clients: {
			title: "For your clients",
			items: [
				"Book without calls",
				"Instant confirmation",
				"Live availability",
				"Automatic reminders",
				"Easy reschedule or cancel",
			],
		},
	},

	visuals: {
		title: "How Sin Fila looks",
		items: ["Calendar view", "Business profile", "Booking screen", "Confirmation"],
	},

	pricing: {
		title: "Simple pricing, everything included",
		mainPrice: "$15 USD / month",
		mainDesc: "First user",
		extraPrice: "$12 USD / month",
		extraDesc: "Each additional user",
		includes: [
			"24/7 online bookings",
			"Automatic confirmations & reminders",
			"Live availability calendar",
			"Public business profile",
			"Promotions & open slots",
			"Cancel anytime",
		],
		note:
			"Pay with debit or credit card. Your bank automatically converts your currency.",
		referral:
			"Referral program: one referral = one free user per month.",
	},

	final: {
		title: "Ready to work without lines?",
		subtitle:
			"Activate your business in 15 minutes. Automatic monthly billing. No contracts.",
		cta: "Start now",
		storeText: "Available on iOS and Android",
	},
};

export default businessLandingEN;
